import { Delete, Edit } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import {
  Delete_Details_Page,
  Enable_Disable_Details_Page,
  Get_Details_Details_Page,
} from "../../../../Apis/detailsPageApi/DetailsPageApi";
import DetailsPageContext from "../../../../context/DetailsPageContext/DetailsPageContext";

const DetailsPageDataTabelContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setdialogs,
    setId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(DetailsPageContext);
  const { isLoading, data, handleOpenandClosePopup, refetch } = props;

  /**
   * get details page Details
   */
  const { mutate: detailsPageDetails, isLoading: isLoadingStoreDetails } =
    useMutation((pageId) =>
      Get_Details_Details_Page(pageId, setFormData, setdialogs)
    );

  const GetDetailsPageDetails = (pageId) => {
    detailsPageDetails(pageId);
    setId(pageId);
    setIsEdit(false);
  };

  /**
   * delete details page
   */
  const { mutate: detailsPageDelete, isLoading: isLoadingDelete } = useMutation(
    (pageId) => Delete_Details_Page(pageId, refetch)
  );

  const DeleteStore = async (pageId) => {
    let { isConfirmed } = await SweetConfirmation();
    if (isConfirmed) {
      detailsPageDelete(pageId);
    }
  };

  /**
   * enable / disable details page
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    Enable_Disable_Details_Page(formData, refetch)
  );

  const handleDetailsPageStatusChange = (pageId, status) => {
    let formDate = {
      pageId: pageId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.pageId === pageId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 250,
      field: "title",
      headerName: "Title",
      renderCell: (params) => (params.row.title ? params.row.title : "--"),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "seoTitle",
      headerName: "SEO Title",
      renderCell: (params) =>
        params.row.seoTitle ? params.row.seoTitle : "--",
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "pageUrl",
      headerName: "Page Url",
      renderCell: (params) => (params.row.pageUrl ? params.row.pageUrl : "--"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handleDetailsPageStatusChange(
                params.row.pageId,
                params.row.isActive
              )
            }
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,

      renderCell: (params) => (
        <>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Edit">
              <IconButton
                aria-label="edit"
                onClick={() => GetDetailsPageDetails(params.row.pageId)}
              >
                <Edit style={{ color: "#7366ff" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Delete">
              <IconButton
                aria-label="delete"
                onClick={() => DeleteStore(params.row.pageId)}
              >
                <Delete style={{ color: "red" }} />
              </IconButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse isLoading={isLoadingStoreDetails || isLoadingDelete} />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.pageId}
        addButton={true}
      />
    </Fragment>
  );
};

export default DetailsPageDataTabelContainer;
